/* eslint-disable consistent-return */
import {
	useEffect, useMemo, useState
} from 'react';

function useVirtulization({
	data = [],
	rowHeight = 50,
	scrollContainerRef,
	visibleCount = 20,
	overscan = 4,
	enabled = false,
}) {
	const [scrollOffset, setScrollOffset] = useState(0);

	useEffect(() => {
		if (!enabled || !scrollContainerRef?.current) return;

		const node = scrollContainerRef.current;
		const handleScroll = () => setScrollOffset(node.scrollTop);

		handleScroll();
		node.addEventListener('scroll', handleScroll);
		return () => node.removeEventListener('scroll', handleScroll);
	}, [scrollContainerRef, enabled]);

	useEffect(() => {
		if (!enabled || !scrollContainerRef?.current) return;
		// eslint-disable-next-line no-param-reassign
		scrollContainerRef.current.scrollTop = 0;
		setScrollOffset(0);
	}, [data.length]);

	const { startIndex, endIndex, paddingTop, paddingBottom } = useMemo(() => {
		if (!enabled) {
			return {
				startIndex: 0,
				endIndex: data.length,
				paddingTop: 0,
				paddingBottom: 0,
			};
		}

		const rawStart = Math.floor(scrollOffset / rowHeight);
		const startIdx = Math.max(0, rawStart - overscan);
		const endIdx = Math.min(
			data.length,
			startIdx + visibleCount + overscan * 2
		);

		return {
			startIndex: startIdx,
			endIndex: endIdx,
			paddingTop: startIdx * rowHeight,
			paddingBottom: Math.max(0, (data.length - endIdx) * rowHeight),
		};
	}, [data.length, enabled, overscan, rowHeight, scrollOffset, visibleCount]);

	const virtualRows = enabled ? data.slice(startIndex, endIndex) : data;

	return {
		virtualRows,
		startIndex,
		endIndex,
		paddingTop,
		paddingBottom,
		totalCount: data.length,
	};
}

export default useVirtulization;
